module.exports = __webpack_public_path__ + "static/media/google-map-location-icon.6d8bc217.png";